import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get Clients 
// export const getClient = createAsyncThunk(
//   "client/get-clients",
//   async (data, { rejectWithValue }) => {
//     let path = `${baseUrl}cleaningappfunctions/crm/app/v1/get-clients`;

//     // If `id` is provided and `page` is not, append the `id` to the path
//     if (data.id && (data.page === undefined || data.page === null)) {
//       path += `/${data.id}`;
//     }

//     const token = localStorage.getItem("authToken");

//     console.log("Request Path:", path); // Debugging: Log the request path
//     console.log("Request Data:", data); // Debugging: Log the request data
   

//     try {
//       const response = await axios.get(path, {
//         headers: {
//           "auth-token": token,
//         },
//         params: data.page ? { page: data.page } : {}, // Pass query parameters if needed
//       });

//       console.log("API Response:", response.data); // Debugging: Log the API response
//       return response.data; // Return only the data from the response
//     } catch (error) {
//       console.error("Error fetching Clients - ", error);
//       return rejectWithValue(error.response?.data || error.message); // Return structured error
//     }
//   }
// );
export const getClient = createAsyncThunk("client/get-clients ", async (data) => {
  let path = null;
  if ((data.page === undefined || data.page === null) && data.id !== undefined && data.id !== null) {
      path = `${baseUrl}cleaningappfunctions/crm/app/v1/get-clients/${data.id}`;
  }
  else {
      path = `${baseUrl}cleaningappfunctions/crm/app/v1/get-clients`;
  }
  const token = localStorage.getItem("authToken")
  try {
    console.log("dataa",data)
      const response = await axios.post(`${path}`, data, {
          headers: {
              "auth-token": token,
          }
      },);
      console.log('clients-----response????????????',response)
      return response;
  } catch (error) {
      console.error('Error fetching clients - ', error);
      throw error;
  }
})


// export const getClient = createAsyncThunk("client/get-clients ", async (data) => {
//     const token = localStorage.getItem("authToken")
//     try {
//         const response = await axios.get(`${baseUrl}cleaningappfunctions/crm/app/v1/get-clients`, data, { 
//             headers: {
//                 "auth-token": token,
//             }
//         },);
//         return response;
//     } catch (error) {
//         console.error('Error fetching client - ', error);
//         throw error;
//     }
// })


export const getClientReladedList = async (id) => {
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.get(`${baseUrl}cleaningappfunctions/crm/app/v1/get-related-clients-list/${id}`, {
        headers: {
          "auth-token": token,
        }
      },)
      return response;
    } catch (error) {
      throw error
    }
  }
